import React from "react";

export const hoverGridContext = React.createContext<[boolean[]]>([[]]);